import React, { useEffect, useCallback, useState} from 'react';
import PatternsComponent from "components/toolbar/PatternsComponent.js"

import {connect} from 'react-redux';

const ZPatterns = ({object, primaryColor, secondaryColor}) => { 
    if (!object.sequencerEngine) {
        return '';
    }
    return (
        <div style={{backgroundColor: primaryColor}}>
          <PatternsComponent secondaryColor={secondaryColor} primaryColor={primaryColor} sequencerEngine={object.sequencerEngine}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZPatterns);
